<template>
  <div class="container-fluid h-100">
    <div class="row justify-content-center align-items-center h-100">
        <div class="col col-sm-6 col-md-6 col-lg-4 col-xl-3 pt-5">
          <card>
            <img class="img-fluid" src="img/breaze-black-logo.png" alt="">
            <!-- <h4 slot="header" class="card-title text-center">Login</h4> -->
            <form>
              <div class="row">
                <div class="col-md-12">
                  <base-input type="text"
                            label="Email Address"
                            placeholder="Email Address"
                            v-model="emailAddress">
                  </base-input>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <base-input type="text"
                            label="Password"
                            placeholder="Password"
                            v-model="password">
                  </base-input>
                </div>
              </div>
              <div class="text-center mb-1">
                <button type="submit" class="btn btn-fill" @click.prevent="attemptLogin">
                  Login
                </button>
              </div>
              <div class="text-center">
                <a href="/#/forgot-password">Forgot Password</a>
              </div>
              <div class="clearfix"></div>
            </form>
          </card>
        </div>
      </div>
  </div>
</template>
<script>
  import { getAuth, setPersistence, signInWithEmailAndPassword, browserLocalPersistence } from "firebase/auth";
  import Card from 'src/components/Cards/Card.vue'

  export default {
    components: {
      Card
    },
    data () {
      return {
        emailAddress: '',
        password: ''
      }
    },
    methods: {
      async attemptLogin () {
        try {
          const email = this.emailAddress; // bind this to your form input
          const password = this.password; // bind this to your form input
      
          const auth = getAuth();
          await setPersistence(auth, browserLocalPersistence)
          const userCredential = await signInWithEmailAndPassword(auth, email, password)
          this.$router.push('/admin/campaigns');
        } catch (error) {
          if (error.code && error.message) alert(`An error occurred. Error: ${error.message}, Code: ${error.code}`)
          else alert(error)
        }
      },
    }
  }

</script>
<style>

</style>
